import { render, staticRenderFns } from "./ProductRuleList.vue?vue&type=template&id=622615d0&scoped=true"
import script from "./ProductRuleList.vue?vue&type=script&lang=js"
export * from "./ProductRuleList.vue?vue&type=script&lang=js"
import style0 from "./ProductRuleList.vue?vue&type=style&index=0&id=622615d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622615d0",
  null
  
)

export default component.exports